<template>
  <div class="panel panel-default">
    <div class="panel-heading">
      <h5>
        {{ headline }}
      </h5>
    </div>

    <div class="panel-body">
      <form @submit.prevent="$emit('submit', data)">
        <TypeaheadFormGroup
            v-model="data.content_article_id"
            name="content_article_id"
            label="Content Article"
            help-text="The article to add to the topic."
            :error="(errors.content_article_id || [])[0]"
            endpoint="/api/v2/content-articles"
            :params="{'filter[portal_id]': portal.id}"
            :token="shared.token"
            path="data.data"
            :result-label-property="getResultLabel"
            :initial-label="data.content_article_title"
        />

        <SubmitFormGroup button-class="btn-black"/>
      </form>
    </div>
  </div>
</template>

<script>
import store from '@/store'
import SubmitFormGroup from '@/vendor/forms/FormGroups/Block/Submit'
import TypeaheadFormGroup from '@/vendor/forms/FormGroups/Block/Typeahead'

export default {
  components: {SubmitFormGroup, TypeaheadFormGroup},

  props: {
    headline: {
      required: true,
      type: String
    },

    initial: {
      required: false,
      type: Object,
      default: () => ({})
    },

    errors: {
      required: true,
      type: Object
    },

    portal: {
      required: true
    }
  },

  data() {
    return {
      data: {...this.initial},

      shared: store
    }
  },

  methods: {
    getResultLabel(contentArticle) {
      if (contentArticle.attributes.publish_at) {
        return this.$options.filters.date(contentArticle.attributes.publish_at) + ' | ' + contentArticle.attributes.title + ' | ' + contentArticle.attributes.portal_company_name
      }

      return contentArticle.attributes.title + ' | ' + contentArticle.attributes.portal_company_name
    }
  }
}
</script>